import ListingCardWrapper from "../listingCard/ListingCardWrapper";
import Pagination from "../common/Pagination";
import PageTitle from "../common/PageTitle";
import SearchBox from "../common/SearchBox";
import { useSearchParams } from "react-router-dom";
import XLoader from "../common/XLoader";
import XCheckbox from "../common/XCheckbox";
import AddCaseButton from "../ui-control/AddCaseButton";
import CaseListTour from "../tour/CaseListTour";
import useCaseList from "../../hooks/useCaseList";
import useCertifiedLifecareCompany from "../../hooks/useCertifiedLifecareCompany";
import useSampleCase from "../../hooks/useSampleCase";
import { TOUR_TARGETS } from "../../constants/tourTargets";
import { cn } from "../../utils/classNames";

const headerRowClasses = 'grid grid-cols-12 items-center gap-4';

const titleColumnClasses = 'col-span-12 md:col-span-4 flex items-center';

const toggleColumnClasses = 'col-span-12 md:col-span-3 flex items-center justify-end gap-4';

const actionColumnBaseClasses = 'col-span-12 md:col-span-5 flex items-center justify-end gap-4';

const actionColumnPadClasses = 'pr-6';

// Holds the width the search box used to own, so anchoring the tour to a
// wrapper does not resize the field
const searchAnchorClasses = 'w-3/5';

const searchFieldClasses = 'w-full';

const tableWrapperClasses = 'dataTables_wrapper no-footer mt-2';

const loaderWrapperClasses = 'flex justify-center';

const tableContentHiddenClasses = 'hidden';

const tableContentRowClasses =
  'flex flex-wrap items-center -mx-3';

const tableContentColumnClasses =
  'w-full max-w-full shrink-0 px-3';

const CaseList = () => {
   const {
      items,
      currentPage,
      totalCount,
      limit,
      isMyCases,
      isCaseListLoading,
      onSearchInputChange,
      setCurrentPage,
      setLimit,
      getCases,
      getCaseListTableOverride,
      setIsMyCases,
   } = useCaseList();

   const [searchParams] = useSearchParams();
   const urlSearch = searchParams.get("search") || "";

   const isCertifiedLifecareCompany = useCertifiedLifecareCompany();
   const { hasSampleCase } = useSampleCase();

   const CaseListTableOverride = getCaseListTableOverride();

   return (
      <ListingCardWrapper>
         <div className={headerRowClasses}>
            <div className={titleColumnClasses}>
               <PageTitle title="Cases" />
            </div>

            <div className={toggleColumnClasses} data-tour={TOUR_TARGETS.CASE_LIST_MY_CASES}>
               <XCheckbox
                  name="flexSwitchCheckDefault"
                  label="Show Only My Cases?"
                  checked={isMyCases}
                  onChange={() => setIsMyCases((prev) => !prev)}
               />
            </div>

            <div
               className={cn(
                  actionColumnBaseClasses,
                  isCertifiedLifecareCompany && actionColumnPadClasses
               )}
            >
               <div className={searchAnchorClasses} data-tour={TOUR_TARGETS.CASE_LIST_SEARCH}>
                  <SearchBox
                     className={searchFieldClasses}
                     onChange={onSearchInputChange}
                     placeholder="Search Cases"
                     defaultValue={urlSearch}
                  />
               </div>

               {!isCertifiedLifecareCompany && (
                  <div data-tour={TOUR_TARGETS.CASE_LIST_ADD_CASE}>
                     <AddCaseButton />
                  </div>
               )}
            </div>
         </div>


         <div id="myTable_wrapper" className={tableWrapperClasses}>
            {isCaseListLoading && (
               <div className={loaderWrapperClasses}>
                  <XLoader />
               </div>
            )}

            <div className={isCaseListLoading ? tableContentHiddenClasses : ""}>
               <div className={tableContentRowClasses}>
                  <div className={tableContentColumnClasses}>
                     <CaseListTableOverride
                        items={items}
                        getCases={getCases}
                        hasSampleCase={hasSampleCase}
                     />
                  </div>
               </div>
               <Pagination
                  totalCount={totalCount}
                  limit={limit}
                  handlePageSizeChange={setLimit}
                  handlePageChange={setCurrentPage}
                  currentPage={currentPage}
               />
            </div>
         </div>

         <CaseListTour isReady={!isCaseListLoading} />
      </ListingCardWrapper>
   );
};

export default CaseList;